import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { ActiveCartFacade, Cart } from '@spartacus/cart/base/root';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CheckoutStepService } from '../../../services/checkout-step.service';
import { CheckoutStep } from '../../../../root';

@Component({
  selector: 'cx-checkout-progress-mobile-top',
  templateUrl: './checkout-progress-mobile-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckoutProgressMobileTopComponent implements OnInit {
  private _steps$: BehaviorSubject<CheckoutStep[]> = this.checkoutStepService.steps$;

  constructor(
    protected activeCartService: ActiveCartFacade,
    protected checkoutStepService: CheckoutStepService
  ) {}

  cart$!: Observable<Cart>;

  activeStepIndex!: number;
  activeStepIndex$: Observable<number> = this.checkoutStepService.activeStepIndex$.pipe(
    tap((index) => (this.activeStepIndex = index))
  );

  get steps$(): Observable<CheckoutStep[]> {
    return this._steps$.asObservable();
  }

  ngOnInit(): void {
    this.cart$ = this.activeCartService.getActive();
  }
}
